<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <loading v-if="! showContent"></loading>
        <h2 class="titulo" v-if="showContent">{{ title }}</h2>
        <div class="peca_musica" id="contato" v-if="showContent">
          <form>
            <div class="" v-show="checkShowErrorMessage()">
              <div class="col col-md-12 errorContent">
                <div v-html="errorMessage"></div>
              </div>
            </div>
            <div class="row successContent" v-show="checkShowSuccessMessage()">
              <div class="col col-md-12">
                <div v-html="successMessage"></div>
              </div>
            </div>
            <label>
              Nome:
              <input type="text" v-model="name">
            </label>
            <label>
              Email:
              <input type="text" v-model="email">
            </label>
            <label>
              Estado:
              <select name="estados-brasil" v-model="state">
                <option value="" selected disabled>Selecione ...</option>
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceará</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espírito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Pará</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
              </select>
            </label>
            <label>
              Cidade:
              <input type="text" v-model="city">
            </label>
            <label class="mensagem">
              Mensagem:
              <textarea v-model="message"></textarea>
            </label>

            <vue-recaptcha ref="recaptcha"  @verify="onVerify" @expired="onExpired" :sitekey="sitekey" class="captcha">
            </vue-recaptcha>
            <button class="btn_enviar" type="button" @click="callback()"> Enviar </button>

          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<style>

  .successContent {
    height: 100%;
    width: 100%;
    background-color: green;
    color: white;
  }
</style>
<script type="text/javascript">
  import {post} from '../../helpers/api';
  import Loading from '../common/Loading.vue';
  import VueRecaptcha from 'vue-recaptcha';


  export default {
    components: {
      Loading,
      VueRecaptcha
    },
    props: ['bloco'],
    data() {
      return {
        title: 'Peça sua música',
        showContent: true,
        items: [],
        name: '',
        email: '',
        city: '',
        state: '',
        message: '',
        errorMessage: '',
        successMessage: '',
        sitekey:window.config.RECAPTCHA_KEY,
        captcha:false
      }
    },
    created() {
      if (this.bloco.nome) {
        this.title = this.bloco.nome;
      }
    },
    methods: {
      onSubmit: function () {
        this.$refs.recaptcha.execute();
      },
      onVerify: function (response) {
        this.captcha = response;
      },
      onExpired: function () {
      },
      resetRecaptcha () {
        this.$refs.recaptcha.reset() // Direct call reset method
      },
      checkShowErrorMessage() {
        return this.errorMessage !== '';
      },
      checkShowSuccessMessage() {
        return this.successMessage !== '';
      },
      clearForm() {
        this.name = '';
        this.email = '';
        this.city = '';
        this.state = '';
        this.message = '';
      },
      callback( ) {
        let formValid = true;

        this.errorMessage = '';
        if (! this.name ) {
          alert('O campo nome é obrigatório.');
          return false;
        }

        if ( ! this.message ) {
          alert('O campo mensagem é obrigatório.');
          return false;
        }
        if (! this.email ) {
          alert('O campo email é obrigatório.');
          return false;
        }
        if ( ! this.captcha   ) {
          alert('Favor marcar captcha.');
          return false;
        }
        // google recaptcha token , then you can pass to backend with your form data .
          this.showContent = false;
          let self = this;
          post('request-music', {
            name: this.name,
            email: this.email,
            city: this.city,
            state: this.state,
            message: this.message
          }).then(function () {
            self.showContent = true;
            swal({
              title: "Pedido enviado com sucesso.",
              icon: "success",
            });
            self.clearForm();
          }).catch(function () {
            self.showContent = true;
            self.errorMessage = '';
            swal({
              title: "Ocorreu um erro ao enviar o pedido, tente novamente mais tarde.",
              icon: "error",
            });
          });
      },
    },
    watch: {
      name(name) {
        if (this.errorMessage !== '' && name.length > 0) {
          this.errorMessage = '';
        }
      },
      message(message) {
        if (this.errorMessage !== '' && message.length > 0) {
          this.errorMessage = '';
        }
      },
      email(email) {
        if (this.errorMessage !== '' && email.length > 0) {
          this.errorMessage = '';
        }
      },
      successMessage(message) {
        if (message.length > 0) {
          let self = this;
          setTimeout(function () {
            self.successMessage = '';
          }, 5000);
        }
      },
      errorMessage(message) {
        if (message.length > 0) {
          let self = this;

        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/home/RequestMusic.vue